<template>
  <div>input</div>
</template>

<script>
export default {
  name: "BaseInput",
};
</script>
